import React from 'react';
import styled from 'styled-components';
import { IImageUploaderState } from './DefaultState';

export interface ImageUploaderWrapperStyle {
    padding: number;
    border: string;
}

const ImageUploaderWrapperStyle = styled.div<ImageUploaderWrapperStyle>`
    padding: 1px;
    z-index: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    img {
        display: block;
        height: 100%;
        width: 100%;
        object-fit: contain;
        padding: ${(props) => props.padding}px;
        border: ${(props) => props.border};
    }
`;
const ImageUploaderTextStyle = styled.div`
    width: 100%;
    font-size: 100%;
    background: #eee;
    display: table;
    height: 100%;
    text-align: center;
    span {
        display: table-cell;
        vertical-align: middle;
    }
`;
export interface IImageUploaderPreview {
    staticBlockState: IImageUploaderState;
}

const ImageUploaderPreview = ({ staticBlockState }: IImageUploaderPreview) => {
    const { settings, image } = staticBlockState;
    const { showBoxAround } = settings;
    const styleImageUploaderWrapperBorder = showBoxAround ? '2px solid rgba(128, 128, 128, 1)' : 'none';
    const styleImageUploaderWrapperPadding = showBoxAround ? 15 : 0;
    console.log('test');

    if (image.url !== '') {
        const { url, altText } = image;

        return (
            <ImageUploaderWrapperStyle border={styleImageUploaderWrapperBorder} padding={styleImageUploaderWrapperPadding}>
                <img src={url} alt={altText} />
            </ImageUploaderWrapperStyle>
        );
    }

    return (
        <ImageUploaderWrapperStyle border={styleImageUploaderWrapperBorder} padding={styleImageUploaderWrapperPadding}>
            <ImageUploaderTextStyle>
                <span>Select ‘Edit’ icon to add image</span>
            </ImageUploaderTextStyle>
        </ImageUploaderWrapperStyle>
    );
};

export default ImageUploaderPreview;
